"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultInclusions = exports.defaultExclusions = exports.BaseInclusions = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultExclusions = exports.defaultExclusions = {
  'coversIllness': false,
  'dental': false,
  'groomingComplication': false,
  'infectiousDisease': false,
  'routineCare': false,
  'preExistingCondition': false,
  'testicular': false
};
var defaultInclusions = exports.defaultInclusions = {
  'accidentalInjury': true,
  'afterLifeCare': true,
  'allergicReactionToInsectOrSpiderBiteExcludingFleaBites': true,
  'alprazolam': true,
  'amitriptyline': true,
  'anaphylacticShock': true,
  'arthritis': true,
  'behaviouralAssessment': true,
  'behaviouralTherapy': true,
  'biteWoundOrFightWoundAbscesses': true,
  'brokenBones': true,
  'burns': true,
  'cancer': true,
  'cancerTreatment': true,
  'catScansMRI': true,
  'cataracts': true,
  'chronic': true,
  'consultation': true,
  'coolingOffPeriod': true,
  'councilRegistration': true,
  'coversAccidentalInjury': true,
  'desexing': true,
  'developmentalHereditary': true,
  'developmentalHereditary2': true,
  'diabetes': true,
  'eligibleVetBills': true,
  'embeddedGrassSeed': true,
  'emergencyBoarding': true,
  'essentialEuthanasia': true,
  'extendedAccidentEvent': true,
  'eyeTrauma': true,
  'felineLowerUrinaryTractDisease': true,
  'fleaControlDrugs': true,
  'fleaTickControlDrugs': true,
  'fleaWormDrugs': true,
  'gastricDilationVolvulusGDV': true,
  'gastrointestinalProblems': true,
  'groomingComplication': false,
  'heartDisease': true,
  'heartWormDrugs': true,
  'heatStroke': true,
  'hereditary': true,
  'hospitalisation': true,
  'hyperthyroidism': true,
  'incidentsEpisodes': true,
  'intestinalWormDrugs': true,
  'jointDysplasiaLuxations': true,
  'jointSupplements': true,
  'joints': true,
  'kidneyDiseases': true,
  'labAndDiagnosticTests': true,
  'laboratoryDiagnosticTests': true,
  'lacerationsOrAbrasionOfTissueSkinOrMucousMembraneDueToExternalViolence': true,
  'medicinesDrugs': true,
  'microchipping': true,
  'minorAilments': true,
  'minorIllnesses': true,
  'motorVehicleIncident': true,
  'oralRinseDrugs': true,
  'pancreatitis': true,
  'petOverseasTravelInsurance': true,
  'preExistingCondition': true,
  'prescriptionDiet': true,
  'radiology': true,
  'routineTeethCleaning': true,
  'skin': true,
  'skinConditions': true,
  'snakeBiteToxicity': true,
  'softTissueInjury': true,
  'specialistCare': true,
  'surgery': true,
  'teethCleaningProducts': true,
  'tornNail': true,
  'traumaInducedRespiratoryImpairment': true,
  'traumaticLigamentInjuryExcludingCruciate': true,
  'traumaticSpinalDiscRupture': true,
  'trazodone': true,
  'vaccinationCat': true,
  'vaccinationDog': true,
  'yourChoiceOfAnyLicensedVet': true
};
var BaseInclusions = exports.BaseInclusions = _objectSpread(_objectSpread({}, defaultInclusions), defaultExclusions);